import { render } from "./MainLayout.vue?vue&type=template&id=797c9311"
import script from "./MainLayout.vue?vue&type=script&setup=true&lang=js"
export * from "./MainLayout.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/core/layout/MainLayout.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "797c9311"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('797c9311', __exports__)) {
    console.log('reload')
    api.reload('797c9311', __exports__)
  }
  
  module.hot.accept("./MainLayout.vue?vue&type=template&id=797c9311", () => {
    console.log('re-render')
    api.rerender('797c9311', render)
  })

}


export default __exports__